export default __webpack_public_path__ + "source-sans-pro-v11-latin-italic-9fbd134e80e91e38b6a82351a30e1e66.bundle.woff";